const FORMAT_OPTS: Intl.DateTimeFormatOptions = {
  hourCycle: 'h23',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

function partsFor(date: Date, tz: string): Intl.DateTimeFormatPart[] {
  try {
    return new Intl.DateTimeFormat('en-US', { timeZone: tz, ...FORMAT_OPTS }).formatToParts(date);
  } catch {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', ...FORMAT_OPTS }).formatToParts(date);
  }
}

export function utcToEventLocal(
  iso: string,
  tz: string | null | undefined,
): { date: string; time: string } {
  const parts = partsFor(new Date(iso), tz || 'UTC');
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return {
    date: `${get('year')}-${get('month')}-${get('day')}`,
    time: `${get('hour')}:${get('minute')}`,
  };
}

export function eventLocalDate(iso: string, tz: string | null | undefined): string {
  return utcToEventLocal(iso, tz).date;
}

export function todayInZone(tz: string | null | undefined, now: Date = new Date()): string {
  return utcToEventLocal(now.toISOString(), tz).date;
}

function offsetMs(t: number, tz: string | null | undefined): number {
  const parts = partsFor(new Date(t), tz || 'UTC');
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value ?? 0);
  return Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute')) - t;
}

export function eventLocalToUtc(date: string, time: string, tz: string | null | undefined): Date {
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  const guess = Date.UTC(year, month - 1, day, hour, minute);
  // The offset at `guess` is wrong on a DST-transition day; re-derive it at the first-pass instant.
  const firstPass = guess - offsetMs(guess, tz);
  return new Date(guess - offsetMs(firstPass, tz));
}
